// extracted by mini-css-extract-plugin
export default {"filterGroupTitleWrapper":"FilterGroup_filterGroupTitleWrapper__Ej6Vj"};